import Menu from '@/api/setting/Menu'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    data: [],
    parents: [],
    positions: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
    },
    SET_PARENTS(state, data) {
      state.parents = data.data
    },
    SET_POSITIONS(state, data) {
      state.positions = data.data
    }
  },
  actions: {
    all({commit}) {
      return Menu.all().then(res => {
        commit('SET_DATA', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    navbar({}) {
      return Menu.navbar().then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    parents({commit}) {
      return Menu.parents().then(res => {
        commit('SET_PARENTS', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    positions({commit}, {parent, params}) {
      return Menu.positions(parent, params).then(res => {
        commit('SET_POSITIONS', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    detail({}, id) {
      return Menu.detail(id).then(res => {
        const {data} = res.data.message
        return data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    store({}, data) {
      return Menu.store(data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    update({}, {id, ...data}) {
      return Menu.update(id, data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    delete({}, id) {
      return Menu.delete(id).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
  },
  getters: {}
}
